import clsx from 'clsx'
import { useEffect, useState } from 'react'
import { useSwiper } from 'swiper/react'

import { CaretIcon } from './CaretIcon'

interface CarouselNextButtonProps {
  disabled?: boolean
  hidden?: boolean
  className?: string
}

export const CarouselNextButton = ({ hidden, className }: CarouselNextButtonProps) => {
  const swiper = useSwiper()
  const [, setIndex] = useState(swiper?.activeIndex ?? 0)

  useEffect(() => {
    if (!swiper) return

    const handleSlideChange = () => {
      setIndex(swiper.activeIndex)
    }

    swiper.on('slideChange', handleSlideChange)
    return () => {
      swiper.off('slideChange', handleSlideChange)
    }
  }, [swiper])
  return (
    <button
      // key={`next-button-${index}`}
      className={clsx(
        'size-10 absolute pl-1 z-20 group disabled:cursor-not-allowed rounded-full bg-white hover:bg-[#D4D4D4] disabled:bg-[#9B9B9B] border-2 border-solid border-black flex justify-center items-center',
        hidden && 'hidden',
        className,
      )}
      onClick={() => swiper.slideNext()}
    >
      <CaretIcon className="size-5" />
    </button>
  )
}
